import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProductTemplateEditor from '@/tiktok-platform/modules/templates/ProductTemplateEditor';
import { TIKTOK_PRODUCT_TEMPLATE_SCOPES } from '@/tiktok-platform/constants/tiktokProductTemplateScope';

/** 商品模板新建/编辑：独立编辑页（不复用发布产品页组件） */
export default function ProductTemplateEditorPage() {
  const { templateId } = useParams();
  const [searchParams] = useSearchParams();
  const scope = searchParams.get('scope') || TIKTOK_PRODUCT_TEMPLATE_SCOPES.personal;
  const referenceShopId = searchParams.get('shopId') || '';
  return (
    <ProductTemplateEditor
      templateId={templateId || ''}
      templateScope={scope}
      referenceShopId={referenceShopId}
    />
  );
}
